import { z } from 'zod'

export const AccentraConnectionSchema = z.object({
  login: z.string().min(1, 'Login is required'),
  password: z.string().min(1, 'Password is required'),
})

export type AccentraConnectionFormValues = z.infer<typeof AccentraConnectionSchema>

export const accentraDefaultValues: AccentraConnectionFormValues = {
  login: '',
  password: '',
}
